(function($,w){$(function(){"use strict";

	// Page Animations
	var PageAnimations = function( $opt ) { this.init( $opt ); }

	$.extend( PageAnimations.prototype,
	{
		init : function( $opt )
		{
			this.vars();
			this.events();
			this.load();
		}, // end init

		vars : function()
		{
			this.tabs = $( 'div.et_pb_tabs' );
		}, // end vars

		load : function()
		{
			if ( '#datenschutz' == location.hash )
				this.tabs.find( 'li.et_pb_tab_1' ).trigger( 'click' );
		}, // end load

		events : function()
		{
			var $this = this;

			this.tabs.find( 'ul.et_pb_tabs_controls' ).find( 'a' ).on( 'click', function()
			{
				TweenMax.to( w, .5, { scrollTo:{ y: $this.tabs, offsetY: ( $( w ).width() > 980 ? 100 : 21 ) }});
			});
		}, // end events
	}); // end PageAnimations

	new PageAnimations({});

});}( jQuery, window ));
